import { string, table } from "@rocicorp/zero";
import { addressFields } from "./shared";

export const organization = table("organizations")
	.columns({
		id: string(),
		name: string(),
		...addressFields,
	})
	.primaryKey("id");
